<template>
  <v-list dense nav>
    <template v-for="item in menuItems">
      <v-list-item
        :key="item.label"
        :input-value="
          item.isWorldCup
            ? item.route.query.event == $route.query.event
            : ($route.path.includes('/bt') && item.route.name === 'bigTable') ||
              ($route.path.includes('/home') &&
                item.route.name === 'Sports' &&
                !$route.path.includes('casino')) ||
              $route.name === item.route.name ||
              (item.route.name === 'myBets' &&
                [
                  'pendentsBets',
                  'closeBets',
                  'liveBets',
                  'resolvedBets',
                  'allBets',
                  'bonusBets',
                ].includes($route.name)) ||
              (item.route.name === 'casinoLobby' &&
                $route.params.casinoType === 'casino') ||
              $route.params.casinoType === 'live'
        "
        v-if="item.show"
        @click="$router.push(item.route).catch(() => {})"
      >
        <v-list-item-icon>
          <div v-if="item.isWorldCup">
            <v-img
              src="https://dozr8la71aog.cloudfront.net/domains/betdasorte/img/custom/icons/sports/54_small.png"
              style="width: 24px; border-radius: 50%"
            />
          </div>
          <template v-else-if="item.icon_img">
            <img class="mb-0" width="24px" :src="item.icon_img" />
          </template>
          <v-icon v-else :class="item.class">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            :class="
              item.isWorldCup ? 'text' : item.icon_img ? 'text-uppercase' : ''
            "
          >
            {{ item.label }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- Favorites -->
    <v-list-item
      :disabled="getFavoritesList.length == 0"
      :input-value="this.$route.name === 'favorites'"
      @click="toRouteFavorite()"
    >
      <v-list-item-icon>
        <template
          v-if="$permissions().customIcons.appbar && showCustomFavoriteImg"
        >
          <v-img
            class="mb-0"
            style="width: 24px"
            :src="`https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/img/custom/icons/appbar/favorites50.png`"
            @error="showCustomFavoriteImg = false"
          />
        </template>
        <v-icon v-else>mdi-star</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title
          :class="$permissions().customIcons.appbar ? 'text-uppercase' : ''"
          v-text="$t('favorites')"
        ></v-list-item-title>
      </v-list-item-content>
      <v-list-item-icon>
        <v-chip small color="rgba(255,255,255,.12)">{{
          getFavoritesList.length
        }}</v-chip>
      </v-list-item-icon>
    </v-list-item>

    <!-- Promotions -->
    <!-- <v-list-item
      v-if="$isCreditOnline() && !$isAgent()"
      :input-value="this.$route.name === 'AllPromotions' || this.$route.name === 'PromotionDetail'"
      @click="$router.push({ name: 'AllPromotions' })"
    >
      <v-list-item-icon>
        <v-icon>mdi-gift-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title v-text="$t('promotions')"></v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->
  </v-list>
</template>
<script>
import mainMenu from "@/util/main-menu.js";
export default {
  name: "main-menu-list",
  data: () => ({
    menuItems: [],
    showCustomFavoriteImg: true,
  }),
  mounted() {
    this.menuItems = mainMenu();
  },
  computed: {
    getFavoritesList() {
      return this.$store.state.favoriteTournaments;
    },
    logged: function () {
      return this.$store.state.logged.status;
    },
  },
  watch: {
    logged(val) {
      // Se o usuário logar, recarregar o menu novamente
      // para mostrar a aba "apostas";
      if (val) {
        this.menuItems = mainMenu();

        const showWorldCup = ["cartola", "dasorte", "betdasorte"];

        this.menuItems.forEach((item) => {
          if (
            item.route.name === "worldCup" &&
            showWorldCup.includes(this.$domain()) &&
            this.$store.state.sports.find((sport) => sport.id_sport == 100)
          ) {
            item.show = !this.$isAgent() && this.$isCreditOnline();
          } else if (item.route.name === "worldCupWinner") {
            const worldCupWinnerSportId = 51;
            const sports = this.$store.state.sports;
            let hasLongTerm = false;

            if (sports) {
              if (
                sports.find((sport) => sport.id_sport == worldCupWinnerSportId)
              ) {
                hasLongTerm = true;
              }
            }

            item.show =
              !this.$isAgent() && this.$isCreditOnline() && hasLongTerm;
          }
        });
      }
    },
    $route() {
      // Atualizar menu ao mudar de idioma
      this.menuItems = mainMenu();
    },
  },
  methods: {
    toRouteFavorite: function () {
      this.$router
        .push({
          name: "favorites",
          params: {
            sport: this.getFavoritesList[0].id_sport,
          },
          query: {
            sport: this.getFavoritesList[0].name_sport,
          },
          hash: "#scrollTop",
        })
        .catch(() => {});
    },
  },
};
</script>
